import { render, staticRenderFns } from "./keywordList.vue?vue&type=template&id=5e2d351e&scoped=true&"
import script from "./keywordList.vue?vue&type=script&lang=js&"
export * from "./keywordList.vue?vue&type=script&lang=js&"
import style0 from "./keywordList.vue?vue&type=style&index=0&id=5e2d351e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d351e",
  null
  
)

export default component.exports